module.exports = __webpack_public_path__ + "static/media/02.6ff87818.mp3";